import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TRANSLATION_SCOPE, translationProvider } from './assets/i18n/translation.provider';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { RxButtonModule } from '@roomex/rx-components';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';

@Component({
  selector: 'rx-applications-ios-modal',
  templateUrl: './ios-modal.component.html',
  styleUrls: ['./ios-modal.component.scss'],
  standalone: true,
  imports: [NgbModalModule, RxButtonModule, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [translationProvider],
})
export class IosModalComponent {
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  logo = inject(BrandingManagerService).getBrandAccess().getLogoFullUrl();
  readonly activeModal: NgbActiveModal = inject(NgbActiveModal);

  close() {
    this.activeModal.close();
  }
}
